<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
    <div class="container">
      <!-- Logo and app name with router-link to home -->
      <router-link class="navbar-brand d-flex align-items-center" to="/" data-id="app-title">
        <svg 
          class="navbar-logo me-3" 
          width="32" 
          height="32" 
          viewBox="0 0 512 512" 
          xmlns="http://www.w3.org/2000/svg"
          aria-label="Agile Tool Chest Logo"
        >
          <path fill="currentColor" d="M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"></path>
        </svg>
        <span class="navbar-title">Agile Tool Chest</span>
      </router-link>
      
      <!-- Welcome message display (when user name is known) -->
      <div v-if="userName" class="navbar-text text-light welcome-display">
        <!-- Small and up: Show text "Welcome {userName}" -->
        <span class="d-none d-sm-inline" style="margin-right: 8px">Welcome <strong>{{ userName }}</strong></span>
        <span class="user-icon" :title="'Welcome ' + userName">
          <i class="bi bi-person-fill fs-2" ":aria-label="'Welcome ' + userName"></i>
        </span>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
interface Props {
  userName?: string;
}

defineProps<Props>();
</script>

<style scoped>
.navbar-logo {
  flex-shrink: 0;
  color: white; /* Ensure SVG is white on the dark navbar */
}

.navbar-title {
  font-weight: 600;
}

.welcome-display {
  font-size: 0.9rem;
  margin-left: auto;
  display: flex;
  align-items: center;
  height: 100%;
}

.user-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
}

/* Responsive layout - condensed on mobile */
@media (max-width: 767.98px) {
  .navbar-brand {
    font-size: 1rem;
  }
  
  .navbar-title {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .navbar-logo {
    width: 24px;
    height: 24px;
  }
  
  .user-icon .bi {
    font-size: 1.25rem !important;
  }
}
</style>